import { Inject, Injectable } from '@angular/core';
import { MmbProxyService } from '@src/components/services/http/ib-mmb-proxy.service';
import { MmBAppConstants } from '@src/ib-MmB-constants';
import { downgradeToAJSService, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {
    IHttpDMResponse, IDownloadPDF, IOverlayModalStatus, DownloadTypeEnum, IDigitalMenuRequest,
    IDigitalMenuDownloadRequest, IDigitalMenuData, ILoadingPDF
} from '../models/digital-menu.model';
import { WINDOW_TOKEN } from '@src/ib-Mmb-app-tokens';
import { IGastroProposalFlightsModel } from '../models/gastronomic-proposal.model';
import dayjs from 'dayjs';

@Injectable()
export class IbDigitalMenuService {

    private overlayModalStatus: IOverlayModalStatus = {
        showLoading: false,
        showError: false,
        errorData: []
    }
    private dataPDF: IDownloadPDF = {
        loading: false,
        documents: [],
        error: false
    }

    private loadingPDFSubject$: Subject<ILoadingPDF> = new Subject();
    private overlayModalStatusSubject$: Subject<IOverlayModalStatus> = new Subject();
    private flightTabSelectedBSubject$: BehaviorSubject<IGastroProposalFlightsModel> = new BehaviorSubject(null);

    loadingPDF$ = this.loadingPDFSubject$.asObservable();
    overlayModalStatus$ = this.overlayModalStatusSubject$.asObservable();
    flightTabSelected$ = this.flightTabSelectedBSubject$.asObservable();


    constructor(
        private mmbProxyService: MmbProxyService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        @Inject(WINDOW_TOKEN) private window: Window
    ) { }

    getRequestDM(fligth: IGastroProposalFlightsModel): IDigitalMenuRequest {
        return {
            flight: {
                cabin: this.getCabinType(fligth.sliceId, fligth.id) || fligth.cabin.type,
                company: fligth.flightInfo.operationalDisclosure,
                departureDate: dayjs(fligth.departureDateTime, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                number: fligth.flightInfo.operationalFlightNumber
            }
        }
    }

    retrieveDigitalMenu(data: IDigitalMenuRequest): Observable<{ code: number, data: IDigitalMenuData }> {
        const enpointDigitalMenu = MmBAppConstants.DEFAULT_ENDPOINTS.digitalMenuURI;
        return this.mmbProxyService.post<IDigitalMenuData>(enpointDigitalMenu, data);
    }

    retrievePDFData(data: IDigitalMenuDownloadRequest) {
        const type: DownloadTypeEnum = this.isMobile() ? DownloadTypeEnum.MOBILE : DownloadTypeEnum.DESKTOP;
        const requestData = { ...data, type }
        const endPointDownloadMenu = MmBAppConstants.DEFAULT_ENDPOINTS.digitalMenuDownloadURI;

        this.mmbProxyService.post<IHttpDMResponse>(endPointDownloadMenu, requestData).subscribe({
            next: response => {
                this.loadingPDFSubject$.next({ loading: false, error: false });
                this.dataPDF.documents = response.data.documents;
            },
            error: () => this.loadingPDFSubject$.next({ loading: false, error: true })
        });
    }

    setOverlayModalStatus(value: IOverlayModalStatus) {
        this.overlayModalStatus = { ...value };
        this.overlayModalStatusSubject$.next(this.overlayModalStatus);
    }

    dowloadMenuPDF() {
        const fileName = this.dataPDF.documents[0].fileName;
        const base64Bytes = this.dataPDF.documents[0].base64Bytes;
        const url = this.generatePDFUrl(base64Bytes);
        const link = document.createElement('a');

        link.download = `${fileName}`;
        link.href = `${url}`;
        link.click();
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }

    updateFlightTabSelected(flight: IGastroProposalFlightsModel) {
        this.flightTabSelectedBSubject$.next(flight);
    }

    private generatePDFUrl(base64: string): string {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = (window.URL).createObjectURL(blob);
        return url;
    }

    private isMobile() {
        return this.window.innerWidth < 1024;
    }

    private getCabinType(sliceId: string, segmentId: string): string | null {
        let cabinType = null;
        const digitalMenuStatus = this.CommonsSessionStorageService.get('digitalMenuStatus') as any;
        if (digitalMenuStatus) {
            const sliceData = digitalMenuStatus.order.slices.find(slice => slice.sliceId === sliceId);
            const segmentData = sliceData.segments.find(segment => segment.id === segmentId);
            cabinType = segmentData.cabin.type;
        }
        return cabinType;
    }

}
downgradeToAJSService(
    'IbDigitalMenuService',
    IbDigitalMenuService,
    'ib-MmB-gastronomic-proposal-module'
);
